import * as React from 'react';
import './Checkbox.scss';
const classnames = require('classnames');

interface CheckboxProps {
  isChecked: boolean;
  onClick?(): void;
}

export const Checkbox = ({ isChecked, onClick }: CheckboxProps) => {
  return (
    <div
      onClick={onClick}
      className={classnames('noble-checkbox', `noble-checkbox--${isChecked ? 'checked' : 'unchecked'}`)}
    />
  );
};
